<template>
	<div class='edit-deal-container content__main is-fixed-block' :class='{[page]: true, "with-deal-info": deal && deal.status=="closed"}'>
		<!-- <header class='edit-deal-container__header'></header> -->
		<div class='content__row content__row--new-deals content__row--with-footer' >
			<a class='edit-deal-container__back' href='/portfolio/' v-if='deal && deal.status=="closed"'>
				<icon icon-name='arrow' />
				<span>Back to my portfolio</span>
			</a>
			<DealList class='deal__info'
				:deal='deal'
				v-if='deal && deal.status=="closed" && !copyPage'
				page='Tenants'
				:showDeleteBtn='false'
				:showEditBtn='false'
			/>
			<div class='edit-deal-container__header edit-deal-container__header--static-padding' v-show='fixed'></div>
			<header class='edit-deal-container__header'
				v-if='title || btnLabel'
				ref='header'
				:class='{"edit-deal-container__header--fixed": fixed}'
				:style='{"width": (fixed)?(`${fixedWidth}px`):("100%")}'
			>
				<h1 class='edit-deal-container__title headline headline--l1 main__headline' v-if='title'>{{title}}</h1>
				<div class='edit-deal-container__btn' @click='$emit("add")' v-if='btnLabel'>
					<icon icon-name='add' />
					<!-- <svg xmlns='http://www.w3.org/2000/svg'
						width='20'
						height='20'
						viewBox='0 0 20 20'
						fill='none'>
						<path d='M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z' fill='#54AE32'/>
					</svg> -->
					<span class='edit-deal-container__btn__label'>{{btnLabel}}</span>
				</div>
			</header>
			<slot />
		</div>
		<slot name='footer' v-if='$slots.footer' />
		<div class='content__footer content__row' v-else-if='!hideFooter'>
			<div class='content__col-12'  @click='$emit("save")'>
				<btn :params='{ label: "Save", class: "waves-light" }' />
			</div>
		</div>
	</div>
</template>

<script>
import DealList from '__jsVueSections/ListOfDeals/components/DealList/DealList.vue';
import EventBus from '__jsEbentBus';
import btn from '__jsVueUI/btn.vue';
import icon from '__jsVueUI/icon.vue';
import top from '__jsVueMixin/top';
export default {
	mixins: [top],
	props:  {
		deal: {
			type: [Object, Boolean]
		},
		page: {
			type:    String,
			default: ''
		},
		title: {
			type:    String,
			default: ''
		},
		btnLabel: {
			type:    String,
			default: ''
		},
		hideFooter: {
			type:    Boolean,
			default: false
		},
		copyPage: {
			type:    Boolean,
			default: false
		},
		toTop: {
			type:    Boolean,
			default: false
		},
	},
	components: {
		DealList,
		btn,
		icon
	},
	created() {
		EventBus.$on('initToTop', () => {
			if (this.toTop) {
				this.initToTop('header', 55);
			}
		});
	},
	beforeDestroy() {
		EventBus.$off('initToTop');
	},
};
</script>
